import React, {useState} from "react";
import {Button, FormControl, Glyphicon, OverlayTrigger, Table, Tooltip} from "react-bootstrap";
import {getHumanDuration, round} from "../../../../tools";
import moment from "moment";
import PaginationBar from "../../../PaginationBar";
import {Link} from "react-router-dom";

const getFieldValue = (client, field) => {
    const value = getClientInfo(client, field.name);

    if (['checkbox', 'disclaimer'].includes(field.type)) {
        // if (value === false) {
        //     return 'Нет';
        // }
        return value ? 'Да' : 'Нет';
    }

    if (field.type === 'konturFocus') {
        return `${value.organizationName} (ИНН: ${value.organizationInn}, КПП: ${value.organizationKpp})`;
    }

    return value;
};

export const getClientInfo = (client, key) => {
    if (!client) {
        return '';
    }

    const socialTypes = {
        guest: 'Гость',
        email: 'COMDI',
        vk: 'Вконтакте',
        facebook: "Facebook",
        twitter: "Twitter",
        mailru: "Mail.ru",
        linkedin: "Linked.in",
        google: "Google",
        ok: "Одноклассники",
        yandex: "Яндекс",
        kaspersky: "Касперский",
    };

    switch(key) {
        case 'link': return client.info.link ? <a href={client.info.link} target="_blank">{socialTypes[client.type] || 'Перейти'}</a> : null;
        default: return client[key] || (client.info ? client.info[key] : null) || '';
    }
};

const RegistrationFieldFilterInput = ({field, value, onChange}) => {
    if (field.type === 'checkbox') {
        return (
            <FormControl
                componentClass="select"
                value={null === value || undefined === value ? '' : (value ? 'on' : 'off')}
                onChange={(e) => {
                    if (!e.target.value) {
                        return onChange(null);
                    }

                    onChange(e.target.value === 'on');
                }}
            >
                <option value={''}>Все</option>
                <option value={'on'}>Да</option>
                <option value={'off'}>Нет</option>
            </FormControl>
        );
    }

    if (field.type === 'select') {
        return (
            <FormControl
                componentClass="select"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Все</option>
                {field.options.map(({id, value, label_ru: label}) => (
                    <option key={id} value={value}>{label}</option>
                ))}
            </FormControl>
        );
    }

    if (field.type === 'konturFocus') {
        return (
            <FormControl
                type="text"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
            />
        );
    }

    return (
        <FormControl
            type={field.type}
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
        />
    );
};

export const StreamWatchClients = ({event, streamDuration, clients, downloadUrl, type, isSummary = false}) => {
    const defaultOrder = 'deviceId';
    const [filterByEmail, setFilterByEmail] = useState('');
    const [filterBySurname, setFilterBySurname] = useState('');
    const [filterByName, setFilterByName] = useState('');
    const [filterByPatronymic, setFilterByPatronymic] = useState('');
    const [filterByRegistrationInfo, setFilterByRegistrationInfo] = useState({});
    const [filterByRegTime, setFilterByRegTime] = useState('');
    const [orderBy, setOrderBy] = useState(defaultOrder);
    const [orderReverse, setOrderReverse] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    if(!clients.length) return null;

    let filteredClients = clients;

    if (filterByEmail) {
        filteredClients = filteredClients.filter((client) => (
            -1 !== getClientInfo(client, 'email')?.toLowerCase()?.indexOf(filterByEmail.toLowerCase())
        ));
    }
    if (filterBySurname) {
        filteredClients = filteredClients.filter((client) => (
            -1 !== getClientInfo(client, 'surname')?.toLowerCase()?.indexOf(filterBySurname.toLowerCase())
        ));
    }
    if (filterByName) {
        filteredClients = filteredClients.filter((client) => (
            -1 !== getClientInfo(client, 'name')?.toLowerCase()?.indexOf(filterByName.toLowerCase())
        ));
    }
    if (filterByPatronymic) {
        filteredClients = filteredClients.filter((client) => (
            -1 !== getClientInfo(client, 'patronymic')?.toLowerCase()?.indexOf(filterByPatronymic.toLowerCase())
        ));
    }
    if (filterByRegTime) {
        if (filterByRegTime === 'before') {
            filteredClients = filteredClients.filter(({registrationTime}) => registrationTime < event.timeStart);
        } else {
            filteredClients = filteredClients.filter(({registrationTime}) => registrationTime >= event.timeStart);
        }
    }
    Object.keys(filterByRegistrationInfo).forEach((key) => {
        const {field, value} = filterByRegistrationInfo[key];
        if (null === value || undefined === value || '' === value) {
            return;
        }
        let filterHandler;

        if (field.type === 'checkbox') {
            filterHandler = (client) => value ? getClientInfo(client, field.name) : !getClientInfo(client, field.name);
        } else if (field.type === 'number') {
            filterHandler = (client) => value === getClientInfo(client, field.name);
        } else if (field.type === 'select') {
            filterHandler = (client) => value.toLowerCase() === getClientInfo(client, field.name)?.toLowerCase();
        } else if (field.type === 'konturFocus') {
            filterHandler = (client) => {
                let data = getClientInfo(client, field.name);
                return -1 !== data.organizationName?.toLowerCase().indexOf(value.toLowerCase())
                    || -1 !== data.organizationInn?.toString().indexOf(value.toLowerCase())
                    || -1 !== data.organizationKpp?.toString().indexOf(value.toLowerCase())
                ;
            }
        } else {
            filterHandler = (client) => -1 !== getClientInfo(client, field.name)?.toLowerCase()?.indexOf(value);
        }

        filteredClients = filteredClients.filter(filterHandler);
    });

    if (orderBy) {
        filteredClients = filteredClients.sort((a, b) => a[orderBy] - b[orderBy])
        if (orderReverse) {
            filteredClients = filteredClients.reverse();
        }
    }

    let pageCount = 0;
    if (limit > 0) {
        pageCount = Math.ceil(filteredClients.length / limit);
        filteredClients = filteredClients.slice((page - 1) * limit, page * limit);
    }

    const hasPolls = filteredClients.length > 0 && filteredClients[0].hasOwnProperty('pollAnswerCount');

    const setOrder = (type) => {
        if (orderBy !== type) {
            setOrderBy(type);
            setOrderReverse(false);
        } else if (false === orderReverse) {
            setOrderReverse(true);
        } else {
            setOrderBy(defaultOrder);
            setOrderReverse(false);
        }
    };

    const OrderMark = ({active, reverse}) => {
        if (!active) {
            return <span style={{opacity: .2}}> ▲</span>;
        }

        return <span> {reverse ? '▼' :  '▲'}</span>;
    }

    const clientViewDurationTooltips = {
        live: {
            event: 'Суммарная продолжительность просмотров видео зрителями, которые зашли на страницу во время прямого эфира. Процент просмотренного контента от суммарной продолжительности прямого эфира во всех залах за выбранный период',
            stream: 'Суммарная продолжительность просмотров видео зрителями, которые зашли на страницу во время прямого эфира. Процент просмотренного контента от прождолжительности прямого эфира в зале/эпизоде за выбранный период',
        },
        record: {
            event: 'Суммарная продолжительность просмотров видео зрителями, которые зашли на страницу после окончания прямого эфира. Процент просмотренного контента от суммарной продолжительности записи из всех залов за выбранный период',
            stream: 'Суммарная продолжительность просмотров видео зрителями, которые зашли на страницу во время прямого эфира. Процент просмотренного контената от прождолжительности всей записи в зале/эпизоде за выбранный период',
        }
    };
    const clientViewDurationTooltip = clientViewDurationTooltips[type][isSummary?'event':'stream'];

    return (
        <div>
            <Table>
                <thead>
                <tr>
                    <th onClick={() => setOrder('deviceId')}>
                        ID устройства
                        <OrderMark active={orderBy === 'deviceId'} reverse={orderReverse} />
                    </th>
                    <th onClick={() => setOrder('id')}>
                        ID зрителя
                        <OrderMark active={orderBy === 'id'} reverse={orderReverse} />
                    </th>
                    <th>eMail</th>
                    <th>Фамилия</th>
                    <th>Имя</th>
                    <th>Отчество</th>
                    {event.registrationFields.map(({field}) => (
                        <th key={field.name}>{field.label_ru}</th>
                    ))}
                    <th onClick={() => setOrder('registrationTime')}>
                        Дата регистрации
                        <OrderMark active={orderBy === 'registrationTime'} reverse={orderReverse} />
                    </th>
                    {streamDuration > 0 &&
                    <th onClick={() => setOrder('watchesDuration')}>
                        <OverlayTrigger placement={"top"} overlay={<Tooltip id={"client-viewDuration"}>{clientViewDurationTooltip}</Tooltip>}>
                            <Glyphicon glyph="question-sign" />
                        </OverlayTrigger>
                        {' '}
                        Просмотрено
                        <OrderMark active={orderBy === 'watchesDuration'} reverse={orderReverse} />
                    </th>}
                    {event.moduleComment.enabled && <th>Комментарии</th>}
                    {event.moduleQuestion.enabled && <th>Вопросы</th>}
                    {hasPolls && <th>Опросы</th>}
                </tr>
                <tr>
                    <th colSpan={2}></th>
                    <th>
                        <FormControl
                            type="text"
                            value={filterByEmail}
                            onChange={(e) => setFilterByEmail(e.target.value)}
                        />
                    </th>
                    <th>
                        <FormControl
                            type="text"
                            value={filterBySurname}
                            onChange={(e) => setFilterBySurname(e.target.value)}
                        />
                    </th>
                    <th>
                        <FormControl
                            type="text"
                            value={filterByName}
                            onChange={(e) => setFilterByName(e.target.value)}
                        />
                    </th>
                    <th>
                        <FormControl
                            type="text"
                            value={filterByPatronymic}
                            onChange={(e) => setFilterByPatronymic(e.target.value)}
                        />
                    </th>
                    {event.registrationFields.map(({field}) => (
                        <th key={field.name}>
                            <RegistrationFieldFilterInput
                                field={field}
                                value={filterByRegistrationInfo[field.name]?.value ?? null}
                                onChange={(value) => {
                                    setFilterByRegistrationInfo({
                                        ...filterByRegistrationInfo,
                                        [field.name]: {field, value}
                                    });
                                }}
                            />
                        </th>
                    ))}
                    {streamDuration > 0 &&
                    <th>
                        <FormControl
                            componentClass="select"
                            value={filterByRegTime}
                            onChange={(e) => setFilterByRegTime(e.target.value)}
                        >
                            <option value="">За всё время</option>
                            <option value="before">До начала</option>
                            <option value="after">После начала</option>
                        </FormControl>
                    </th>}
                    {streamDuration > 0 && <th>{' '}</th>}
                    {event.moduleComment.enabled && <th>{' '}</th>}
                    {event.moduleQuestion.enabled && <th>{' '}</th>}
                    {hasPolls && <th>{' '}</th>}
                </tr>
                </thead>
                <tbody>
                {filteredClients.map((client) => (
                    <tr key={`${client.deviceId}-${client.id}`}>
                        <td>{client.deviceId}</td>
                        {client.id ? <>
                        <td><Link to={`/event/${event.eventPassword}/client/${client.id}`}>{client.id}</Link></td>
                        <td>{getClientInfo(client, 'email') ?? '-'}</td>
                        <td>{getClientInfo(client, 'surname') ?? '-'}</td>
                        <td>{getClientInfo(client, 'name') ?? '-'}</td>
                        <td>{getClientInfo(client, 'patronymic') ?? '-'}</td>
                        {event.registrationFields.map(({field}) => (
                            <td key={field.name}>{getFieldValue(client, field) ?? '-'}</td>
                        ))}
                        <td>{client.registrationTime ? moment.unix(client.registrationTime).format('YYYY-MM-DD HH:mm:ss') : ''}</td>
                        </>
                            : <td colSpan={6 + event.registrationFields.length} style={{textAlign: 'center'}}>
                                Не авторизован
                            </td>
                        }
                        {streamDuration > 0 && <td>
                            {getHumanDuration(client.watchesDuration, true)}
                            {' '}
                            ({round(client.watchesDuration/streamDuration*100, 2)}%)
                        </td>}
                        {event.moduleComment.enabled && <td>{client.commentCount}</td>}
                        {event.moduleQuestion.enabled && <td>{client.questionCount}</td>}
                        {hasPolls && <td>{client.pollAnswerCount}</td>}
                    </tr>
                ))}
                </tbody>
                <tfoot>
                <tr>
                    <td colSpan={2}>
                        <FormControl
                            componentClass="select"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            {[0,10,20,50,100,200].map((count) => (
                                <option key={count} value={count}>Показать {count > 0 ? count : 'все'}</option>
                            ))}
                        </FormControl>
                    </td>
                    {downloadUrl && <td>
                            <Button href={downloadUrl}>Скачать статистику по зрителям</Button>
                    </td>}
                    <td colSpan={20} style={{textAlign: 'right'}}>
                        {pageCount > 1 &&
                            <PaginationBar
                                pageCount={pageCount}
                                activePage={page}
                                onSelect={(page) => setPage(page)}
                            />
                        }
                    </td>
                </tr>
                </tfoot>
            </Table>
        </div>
    );
};
